import { render, staticRenderFns } from "./DeleteComplaintButton.vue?vue&type=template&id=e1c6ae26&scoped=true&"
import script from "./DeleteComplaintButton.vue?vue&type=script&lang=js&"
export * from "./DeleteComplaintButton.vue?vue&type=script&lang=js&"
import style0 from "./DeleteComplaintButton.vue?vue&type=style&index=0&id=e1c6ae26&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c6ae26",
  null
  
)

export default component.exports